import _ from 'lodash'
import React, { Component } from 'react'
import autoBind from 'react-autobind'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { Container, Dropdown, Grid, Image, Segment } from 'semantic-ui-react'

import logo from '../../assets/images/logo.png'
import { authenticate } from '../../helpers/auth'
import { setLanguage, tr } from '../../helpers/languages'
import LoginForm from './form'
import { actions as messages } from '../../store/actions/messages'
import { actions as settings } from '../../store/actions/settings'
import cookie from 'react-cookies'

class Login extends Component {
    constructor (props) {
        super(props)
        this.state = {
            email: '',
            password: '',
            language: 'en',
            errors: {},
            doNotDisturb: false
        }
        autoBind(this)
    }

    // Changes the value of some field.
    changeValue (field, value) {
        this.setState({ [field]: value })
    }

    // Authenticates a therapist.
    logIn () {
        // Do not disturb.
        if (this.state.doNotDisturb) {
            return
        }

        // Put the do not disturb sign, and clear all errors.
        this.setState({ doNotDisturb: true, errors: {} })

        // Validate.
        let errors = {}

        // The email is required.
        if (_.isEmpty(this.state.email)) {
            errors = { ...errors, email: tr('EMAIL_REQUIRED') }
        }
        // The password is required.
        if (_.isEmpty(this.state.password)) {
            errors = { ...errors, password: tr('PASSWORD_REQUIRED') }
        }

        // There are errors. Break.
        if (!_.isEmpty(errors)) {
            this.setState({ doNotDisturb: false, errors })
            return
        }

        // Authenticate.
        return authenticate({
            username: this.state.email,
            password: this.state.password
        })
            .catch((error) => {
                // Failed to authenticate the therapist.
                // eslint-disable-next-line no-console
                console.error('Failed to log in.', error)
                this.props.message({ type: 'error', text: tr('FAILED_TO_LOG_IN') })
                this.setState({ doNotDisturb: false })
            })
    }

    changeLang (language) {
        this.changeValue('language', language)
        cookie.save('language', language, { path: '/' })
        setLanguage(language)
    }

    render () {
        return (
            <Container className='login'>
                <Link to='/'>
                    <Image className='logo' src={logo} centered/>
                </Link>
                <Grid className='segment centered'>
                    <LoginForm
                        {...this.state}
                        onChangeValue={this.changeValue}
                        onLogIn={this.logIn}
                    />
                </Grid>
                <Segment className='language-segment'>
                    <div role='link' tabIndex={0} className='link lang'>
                        <Dropdown
                            className={'language-selection'}
                            fluid
                            selection
                            icon='angle down'
                            options={
                                [
                                    {
                                        value: 'en',
                                        text: 'EN'
                                    },
                                    {
                                        value: 'de',
                                        text: 'DE'
                                    }
                                ]
                            }
                            value={cookie.load('language') ? cookie.load('language') : 'en'}
                            onChange={(_e, { value }) => {this.changeLang(value)}}
                        />
                    </div>
                </Segment>
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language
    }
}

const mapDispatchToProps = (dispatch) => {
    const _messages = bindActionCreators(messages, dispatch)
    const _settings = bindActionCreators(settings, dispatch)
    return {
        setLanguage: _settings.setLanguage,
        message: _messages.message
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login))



// WEBPACK FOOTER //
// ./src/components/login/index.js